import { render } from "./Auspiciantes.vue?vue&type=template&id=eabb1d5e"
import script from "./Auspiciantes.vue?vue&type=script&lang=js"
export * from "./Auspiciantes.vue?vue&type=script&lang=js"

import "./Auspiciantes.vue?vue&type=style&index=0&id=eabb1d5e&lang=css"

import exportComponent from "D:\\Trabajo\\Raxar\\backoffice-base-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__